var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"grow hidden-sm-and-down",attrs:{"contain":"","max-height":"200","width":"100%","position":"top right","src":require('@/assets/bubbles1.png')}})}
var staticRenderFns = []

export { render, staticRenderFns }